<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Review Entity</div>
          </v-flex>
          <v-flex text-right>
            <v-chip
              :color="state.toLowerCase() === 'reviewed' ? 'green' : 'orange'"
              dark
              label
            >
              {{ state.toUpperCase() }}
            </v-chip>
            <v-btn icon @click="cancel()">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the name of the Entity?</div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Entity Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Subtitle</div>
              <v-text-field
                v-model="subtitle"
                hide-details
                dense
                outlined
                placeholder="Entity Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                v-model="latitude"
                hide-details
                dense
                outlined
                placeholder="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                v-model="longitude"
                hide-details
                dense
                outlined
                placeholder="Logitude"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Address</div>
              <v-text-field
                v-model="address"
                hide-details
                dense
                outlined
                placeholder="Address"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-layout class="mt-3">
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Type</div>
              <v-select
                outlined
                dense
                return-object
                hide-details
                :items="entityTypes"
                v-model="entityType"
                item-text="name"
                placeholder="Entity Type"
              >
              </v-select>
            </v-flex>
          </v-layout> -->
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                return-object
                hide-details
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Facebook</div>
              <v-text-field
                v-model="facebook"
                hide-details
                dense
                outlined
                placeholder="Facebook"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Instagram</div>
              <v-text-field
                v-model="instagram"
                hide-details
                dense
                outlined
                placeholder="Instagram"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Website</div>
              <v-text-field
                v-model="website"
                hide-details
                dense
                outlined
                placeholder="Website"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Phone Number</div>
              <v-text-field
                v-model="phoneNumber"
                hide-details
                dense
                outlined
                placeholder="Phone Number"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Emails</div>
              <v-combobox
                v-model="emails"
                :items="emails"
                placeholder="Emails"
                hint="Create emails by typing a word and pressing enter"
                multiple
                outlined
                chips
                hide-details
                hide-selected
                deletable-chips
                dense
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Category</div>
              <v-text-field
                v-model="categoryName"
                placeholder="Cateogry"
                outlined
                hide-details
                dense
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Tags</div>
              <v-combobox
                :loading="loading"
                v-model="tags"
                :items="tagItems"
                cache-items
                :search-input.sync="searchTerm"
                item-text="name"
                item-value="name"
                placeholder="Tags"
                menu-props="closeOnContentClick, closeOnClick"
                persistent-hint
                hint="Create tags by typing a word and pressing enter"
                multiple
                outlined
                chips
                deletable-chips
                dense
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-1 font-weight-medium">Defaults</div>
            </v-flex>
          </v-layout>
          <v-layout class="mt-1">
            <v-flex>
              <div class="subtitle-2 mb-1">Pin Type</div>
              <v-select
                outlined
                dense
                return-object
                hide-details
                :items="pinTypes"
                v-model="defaultPinType"
                item-text="name"
                placeholder="Pin Type"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Link Name</div>
              <v-text-field
                v-model="defaultLinkName"
                hide-details
                dense
                outlined
                placeholder="Link Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">Link URL</div>
              <v-text-field
                v-model="defaultLinkUrl"
                hide-details
                dense
                outlined
                placeholder="Ex: http://..."
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="$route.name !== 'Reviewed'">
            <v-checkbox
              v-model="markReviewed"
              hide-details
              label="Mark entity as reviewed."
            />
          </v-layout>
        </v-flex>
      </v-layout>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import firebase from 'firebase';
export default {
  props: {
    details: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      markReviewed: false,
      dialog: false,
      categoryName: "",
      name: '',
      subtitle: '',
      latitude: '',
      longitude: '',
      address: '',
      region: '',
      facebook: '',
      instagram: '',
      website: '',
      phoneNumber: '',
      state: '',
      // entityType: '',
      tags: [],
      defaultPinType: {},
      defaultLinkName: '',
      defaultLinkUrl: '',
      emails: [],
      id: '',
      searchTerm: '',
      categiryName: '',
      loading: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions', 'tagItems', 'pinTypes']),
    tagNames() {
      var arr = [];
      this.tags.forEach((tag) => {
        if (tag.name) {
          arr.push(tag.name);
        } else {
          arr.push(tag);
        }
      });
      return arr;
    },
    changeFields() {
      return {
        title: this.name,
        subTitle: this.subtitle,
        location: new firebase.firestore.GeoPoint(
          parseFloat(this.latitude),
          parseFloat(this.longitude),
        ),
        categoryName: this.categoryName,

        region: this.region,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        website: this.website,
        phone: this.phoneNumber,
        tags: this.tagNames,
        emails: this.emails,
        // entityType: this.entityType.name
        //   ? this.entityType.name
        //   : this.entityType,
        default: {
          pinType: this.defaultPinType,
          linkUrl: this.defaultLinkUrl,
          linkName: this.defaultLinkName,
        },
        state: this.markReviewed ? 'reviewed' : 'in-review',
        id: this.id,
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchTag(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    // this.getEntityTypes({
    //   collection: 'entityTypes',
    //   mutation: 'updateEntityTypes',
    // });
    // this.getTags({ collection: "tags", mutation: "updateTags" });
  },
  methods: {
    ...mapActions({
      updateEntity: '$_entity/updateContent',
      getEntities: '$_entity/getContent',
      getRegions: '$_home/getContent',
      getEntityTypes: '$_home/getContent',
      getPinTypes: '$_home/getContent',
      createNewEnitity: '$_entity/createNewContent',
      createNewTag: '$_home/createNewContent',
      getTags: '$_home/getContent',
      searchTags: '$_home/searchContent',
    }),
    searchTag(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchTags({
        collection: 'tags',
        mutation: 'updateTags',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    toggleDialog(details) {
      this.dialog = !this.dialog;
      console.log('opening edit');
      if (this.dialog) {
        console.log(this.details);
        this.name = details.title ? details.title : '';
        this.subtitle = details.subTitle ? details.subTitle : '';
        this.latitude = details.location.latitude
          ? details.location.latitude
          : 0;
        this.longitude = details.location.longitude
          ? details.location.longitude
          : 0;
        this.region = details.region ? details.region : '';
        this.address = details.address ? details.address : '';
        this.facebook = details.facebook ? details.facebook : '';
        this.instagram = details.instagram ? details.instagram : '';
        this.website = details.website ? details.website : '';
        this.phoneNumber = details.phone ? details.phone : '';
        this.tags = details.tags ? details.tags : [];
        this.categoryName = details.categoryName ? details.categoryName : '';

        this.emails = details.emails ? details.emails : [];
        this.state = details.state ? details.state : '';
        // this.entityType = details.entityType ? details.entityType : '';
        this.defaultPinType = details.default ? details.default.pinType : {};
        this.defaultLinkName = details.default ? details.default.linkName : '';
        this.defaultLinkUrl = details.default ? details.default.linkUrl : '';
        this.id = details.id;
      }
    },
    cancel() {
      this.name = '';
      this.subtitle = '';
      this.latitude = '';
      this.longitude = '';
      this.address = '';
      this.region = '';
      this.facebook = '';
      this.instagram = '';
      this.website = '';
      this.phoneNumber = '';
      this.state = '';
      // this.entityType = '';
      this.tags = [];
      this.emails = [];
      this.categoryName = '';
      this.id = '';
      this.searchTerm = '';
      this.defaultPinType = {};
      this.defaultLinkName = '';
      this.defaultLinkUrl = '';
      this.dialog = false;
    },

    save() {
      console.log('Save Entity: ', this.changeFields);
      if (Object.keys(this.region).length === 0) {
        alert("Yo yo, Slow down dude, add a Region");
        return;
      }
      this.changeFields.tags.forEach((tag) => {
        const newTag = {
          name: tag.toLowerCase(),
        };
        this.createNewTag({
          details: newTag,
          collection: 'tags',
          type: 'Tag',
        });
      });

      this.updateEntity({
        details: this.changeFields,
        collection: 'entities',
        type: 'Entity',
      }).then(() => {
        this.cancel();
        this.getEntities({
          collection: 'entities',
          mutation: 'updateEntities',
          condition: {
            leftVal: 'state',
            operator: '==',
            rightVal: 'in-review',
          },
        });
      });
    },
  },
};
</script>

<style></style>
